import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'animate.css';
import './css/media.css';
// import './css/style.css';
import './css/style-scss.css';


import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDU8k-UKBsmw-61W5Ic1qrAienn7Uw-8Dk",
  authDomain: "egarhub-listing-react.firebaseapp.com",
  projectId: "egarhub-listing-react",
  storageBucket: "egarhub-listing-react.firebasestorage.app",
  messagingSenderId: "37469077475",
  appId: "1:37469077475:web:6e518b50d0b0117754aad6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
